export default theme => ({
  userInfo: {
    marginTop: theme.spacing.unit * 3,
    marginBottom: theme.spacing.unit * 6
  },
  buttonWrapper: {
    marginTop: theme.spacing.unit * 4
  }
})
